import { FC, useEffect, useState } from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import {
    SearchSelectWithEnum,
} from "../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTable } from "../../../components/common/datatable/DataTable";
import IconButton from "../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { useLazyExportCollectorLinkDataQuery, useSearchCollectorLinksQuery } from "./collectorLinkApi";
import { useGetEnumsQuery } from "../../../app/globalApi";
import CollectorSearchInputWrapper from "../../../components/common/datatable/filter/CollectorSearchInputWrapper";


const CollectorLink: FC = () => {

    const navigate = useNavigate()

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Collector Links", url: "" },
    ])

    useEffect(() => {
        document.title = "Collector Link";
    });

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Collector Link");
    const [triggerExportCollectorLinkDataQuery] = useLazyExportCollectorLinkDataQuery();
    const { data: enums } = useGetEnumsQuery("");

    const columns: DataTableColumn[] = [
        {
            label: "Collector",
            accessor: "collector.name",
            cell: (props: any) => {
                let path = `/collector-links/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["COLLINK-R"]);
            },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorName" />,
                overrideFilterAccessor: "collectorName",
                overrideFilterLabel: "Collector",
            }]

        },

        {
            label: "Type", accessor: "type",
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["CollectorLinkType"], "Select Collector Link Type...", false, "types", null),
                overrideFilterLabel:"Link Types",
                overrideFilterAccessor:"types"
            }]
            
        },
        {
            label: "Url", accessor: "url", overrideSortColumn: "url", visibility: {
                hasShowSetting: false,
            }, canSort: false,
            cell: (props: any) => {
                return <span>
                    {props.value !== null ?
                        <a href={props.value} className="fa fa-globe text-highlight-0" title={props.value} target="_blank" /> : "-"}
                </span>;
            },
        },
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchCollectorLinksQuery,
                    exportAction: triggerExportCollectorLinkDataQuery
                }}
                userSettingGroup={"Collector Link"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}

                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/collector-links/create")
                            }}
                            title={"Create Collector Link"}
                        />,
                        permissions: ["COLLINK-C"]
                    },
                }}
                basePermission={"COLLINK"}
            />

        </div>

    )
}
export default CollectorLink